module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-metals.b99c3e4d.png";